<h3 class="text-lg text-bold">Requests</h3>

<div class="flex flex-col gap-2 overflow-auto max-h-[85vh]">
  @for (log of logs(); track log) {
    <soft-request-log [log]="log"></soft-request-log>
  }
</div>
